import Snackbar from '@mui/material/Snackbar'
import TextField from '@mui/material/TextField'
import { useFormik } from 'formik'
import * as React from 'react'
import { CardTitleDescription } from '../../../../components/CardTitleDescription'
import { useAssistantAdministrationStore } from '../../../../store/storeAssistantAdministration'
import { useRequestsStore } from '../../../../store/storeRequests'
import { useWrapperStore } from '../../../../store/storeWrapper'
import { ActionButton } from '../../ProfilePage/components/ActionButton'

const FAIL_MESSAGE = 'Не удалось сохранить изменения. Попробуйте еще раз'

export const ContextSettingCard = ({ isRequestPage }) => {
    const [openSnackbar, setOpenSnackbar] = React.useState(false)
    const {
        updateRequest,
        errorUpdateRequest,
        requestDetail,
        isLoadingUpdateRequest,
        setRequestSettingContext,
        requestSettingContext,
    } = useRequestsStore((state) => state)
    const { projectDetail, updateProjectDetail } = useWrapperStore((state) => state)
    const { updateWorkplace } = useAssistantAdministrationStore((state) => state)
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            context: isRequestPage
                ? requestDetail?.id
                    ? requestDetail?.context
                    : requestSettingContext
                : projectDetail?.context,
        },
        onSubmit: async (values) => {
            if (isRequestPage) {
                if (requestDetail?.id) {
                    await updateRequest({ threadId: requestDetail.id }, { context: values.context })
                } else {
                    setRequestSettingContext(values.context)
                }
            } else {
                await updateWorkplace(
                    { workplaceId: projectDetail?.id },
                    { context: values.context },
                )
                updateProjectDetail({ context: values.context })
            }

            setOpenSnackbar(true)
        },
    })

    const handleCloseSnackbar = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return
        }

        setOpenSnackbar(false)
    }

    return (
        <>
            <CardTitleDescription
                title={`Контекст ${isRequestPage ? 'запроса' : 'проекта'}`}
                description={
                    <>
                        Опишите нужный формат, ключевые детали и стиль расшифровки,
                        <br />
                        например: писать на русском языке, кратко или подробно, в деловом стиле
                    </>
                }
                isBorder={false}>
                <form onSubmit={formik.handleSubmit}>
                    <TextField
                        id="context"
                        name="context"
                        value={formik.values.context}
                        onChange={formik.handleChange}
                        onBlur={async (evt) => {
                            formik.handleBlur(evt)

                            if (!isRequestPage) {
                                await formik.submitForm()
                            }
                        }}
                        multiline
                        rows={6}
                        sx={{
                            marginTop: 4,
                            mb: 1,
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '24px',
                            },
                        }}
                        placeholder="Пример: Пиши на русском языке, используй деловой стиль"
                        fullWidth
                        slotProps={{
                            htmlInput: {
                                maxLength: 10000,
                            },
                        }}
                        error={formik.touched.context && Boolean(formik.errors.context)}
                        helperText={formik.touched.context && formik.errors.context}
                    />
                    {isRequestPage ? (
                        <ActionButton
                            id="context_settings_save_button"
                            type="submit"
                            disabled={!(formik.isValid && formik.dirty) || isLoadingUpdateRequest}
                            variant="contained">
                            Сохранить
                        </ActionButton>
                    ) : null}
                </form>
            </CardTitleDescription>

            <Snackbar
                className={errorUpdateRequest ? 'snackbar-error' : 'snackbar-success'}
                open={openSnackbar}
                autoHideDuration={2000}
                onClose={handleCloseSnackbar}
                message={
                    errorUpdateRequest
                        ? FAIL_MESSAGE
                        : `Контекст ${isRequestPage ? 'запроса' : 'проекта'} успешно изменен!`
                }
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            />
        </>
    )
}
